import { money } from "@/lib/api";
import { earnings } from "@/lib/earnings";

const Row = ({ label, value, strong, muted, testid }) => (
  <div className={`flex justify-between text-sm ${strong ? "font-semibold text-stone-900" : "text-stone-600"} ${muted ? "text-stone-400 line-through" : ""}`}>
    <span>{label}</span>
    <span className="font-mono-num" data-testid={testid}>{value}</span>
  </div>
);

export function GuestBreakdown({ q, price, taxRules = [] }) {
  const capped = (t) => t.taxed_nights_cap > 0 && q.nights > t.taxed_nights_cap;
  const taxes = taxRules.map((t) => ({ ...t, amount: Math.round(q.total * t.rate * (capped(t) ? t.taxed_nights_cap / q.nights : 1)) / 100 }));
  const exempt = taxRules.filter(capped);
  const charged = taxes.filter((t) => t.mode === "charge").reduce((s, t) => s + t.amount, 0);
  return (
    <div className="space-y-4" data-testid="price-breakdown">
      <div className="space-y-2">
        <Row label={`${money(price)} × ${q.nights} night${q.nights > 1 ? "s" : ""}`} value={money(q.nightly)} />
        {q.cleaning > 0 && <Row label="Cleaning fee (set by host)" value={money(q.cleaning)} />}
        <div className="flex items-center justify-between text-sm">
          <span className="text-stone-600">FairStay service fee</span>
          <span className="rounded-full bg-emerald-50 px-2 py-0.5 font-mono-num text-xs font-semibold text-emerald-700">$0.00</span>
        </div>
        {taxes.map((t) => (
          <Row key={t.name} label={`${t.name} (${t.rate}%)${t.mode === "estimate" ? " · estimate, not charged" : ""}`} value={money(t.amount)} testid={`breakdown-tax-${t.name.toLowerCase().replace(/\W+/g, "-")}`} />
        ))}
        {exempt.map((t) => <p key={t.name} className="text-xs text-stone-500" data-testid="breakdown-tax-exempt">{t.name}: only the first {t.taxed_nights_cap} nights are taxed; nights {t.taxed_nights_cap + 1}+ are exempt.</p>)}
        <div className="border-t pt-2"><Row label="Total you pay" value={money(q.total + charged)} strong testid="breakdown-total" /></div>
      </div>
      <div className="rounded-2xl border bg-stone-50 p-4" data-testid="fee-comparison-card">
        <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-stone-600">Same stay elsewhere (estimates)</p>
        {earnings(q.total, q.total ? (charged / q.total) * 100 : 0).slice(1).map((r) => (
          <Row key={r.key} label={`${r.name} · ${r.guestPct ? `${r.guestPct}% guest fee` : "no guest fee"}`} value={money(r.guestTotal)} testid={`breakdown-compare-${r.key}`} />
        ))}
        <p className="mt-2 text-xs text-stone-500" data-testid="breakdown-compare-note">Typical published fees; they vary by listing. On Airbnb's host-only plan the guest fee is usually built into the nightly price instead.</p>
      </div>
    </div>
  );
}
